import { render, staticRenderFns } from "./IcoArticleContent.vue?vue&type=template&id=4ea363f6"
import script from "./IcoArticleContent.vue?vue&type=script&lang=js"
export * from "./IcoArticleContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports